
import { requestOptions } from '../helpers/request-options'
import { handleResponse } from '../helpers/handle-response'

export const opportunityService = {
  getData,
  getDataById,
  deleteDataById,
  update,
  add,
  uploadFile,
  getFileFile,
  deleteFile,
  addV2,
  updateWithPath
}

function getData ({ q, limit, ordering, offset }) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/opportunities/?${q}&limit=${limit}&ordering=${ordering}&offset=${offset}&expand=created_by,modified_by,tags`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(opportunities => {
      return opportunities
    })
}

function getDataById (id, noExpand) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/opportunities/${id}/?expand=${noExpand ? '' : 'created_by,modified_by,tags,bids,bids.opportunity,bids.utility_state,bids.legal_entity,organizations,organizations.addresses'}`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(opportunities => {
      return opportunities
    })
}

function deleteDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/opportunities/${id}/`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(opportunities => {
      return opportunities
    })
}

function add (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/opportunities/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(opportunities => {
      return opportunities
    })
}

function addV2 (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/opportunities/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(opportunities => {
      return opportunities
    })
}

function update (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/opportunities/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(opportunities => {
      return opportunities
    })
}

function updateWithPath (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/opportunities/${id}/`
  return fetch(url, requestOptions.patch(payload))
    .then(handleResponse)
    .then(opportunities => {
      return opportunities
    })
}

function uploadFile (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/`
  return fetch(url, requestOptions.postFormData(payload))
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function getFileFile (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/?limit=9999999&object_id=${id}`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function deleteFile (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/${id}`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(data => {
      return data
    })
}



// WEBPACK FOOTER //
// ./src/services/opportunities.service.js